export function defer(task) {
    return Promise.resolve(task).then(runTask);
}
export function runTask(task) {
    try {
        return task.run(Date.now());
    }
    catch (e) {
        return task.error(Date.now(), e);
    }
}
export function runScheduledTask(task) {
    try {
        task.run();
    }
    catch (e) {
        task.error(e);
    }
}
//# sourceMappingURL=task.js.map